import { rest } from 'msw'

import { config } from '@percent/admin-dashboard/config'
import {
  mockCandidateDetailFields,
  mockCandidates
} from '@percent/admin-dashboard/fixtures/api/grantProgram/mockCandidates'
import { mockCandidateTasks } from '@percent/admin-dashboard/fixtures/api/grantProgram/mockCandidateTasks'
import { mockFormDetails } from '@percent/admin-dashboard/fixtures/api/grantProgram/mockFormDetails'
import { mockGrantPrograms } from '@percent/admin-dashboard/fixtures/api/grantProgram/mockGrantPrograms'
import { mockGrantProgramForms } from '@percent/admin-dashboard/fixtures/api/grantProgram/mockGrantProgramForms'
import {
  mockStandaloneFormQuestionDetails,
  mockStandaloneFormQuestionsResponse
} from '@percent/admin-dashboard/fixtures/api/grantProgram/mockStandaloneFormQuestions'
import { mockTaskAssignees } from '@percent/admin-dashboard/fixtures/api/grantProgram/mockTaskAssignees'
import { mockTaskAutoAssignmentRules } from '@percent/admin-dashboard/fixtures/api/grantProgram/mockTaskAssignmentRules'
import { mockStateMachineMetadata } from '@percent/admin-dashboard/fixtures/api/grantProgram/mockStateMachineMetadata'
import { mockTaskTemplates } from '@percent/admin-dashboard/fixtures/api/grantProgram/mockTaskTemplates'

export const grantProgramsHandlers = [
  rest.post(`${config.urls.api}v2/admin/grants/forms`, async (_req, res, ctx) => {
    return res(ctx.status(201), ctx.json({ data: { id: 'new-form-id-001' } }))
  }),
  rest.get(`${config.urls.api}v1/admin/grants/task-templates`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: mockTaskTemplates }))
  }),
  rest.post(`${config.urls.api}v1/admin/grants/task-templates`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: mockTaskTemplates[0] }))
  }),
  rest.get(`${config.urls.api}v1/admin/grants/:id/task-templates`, (_, res, ctx) =>
    res(
      ctx.status(200),
      ctx.json({
        data: mockTaskTemplates,
        totalResults: mockTaskTemplates.length
      })
    )
  ),
  rest.get(`${config.urls.api}v1/admin/grants/forms`, (_, res, ctx) =>
    res(
      ctx.status(200),
      ctx.json({
        data: mockGrantProgramForms,
        totalResults: mockGrantProgramForms.length
      })
    )
  ),
  rest.get(`${config.urls.api}v1/admin/grants/programs`, async (req, res, ctx) => {
    const search = req.url.searchParams.get('search')
    let filtered = mockGrantPrograms

    if (search) {
      filtered = mockGrantPrograms.filter(p => p.name.toLowerCase().includes(search.toLowerCase()))
    }

    return res(
      ctx.status(200),
      ctx.json({
        data: filtered,
        totalResults: filtered.length
      })
    )
  }),
  rest.get(`${config.urls.api}v1/admin/grants/programs/:id`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: mockGrantPrograms[0] }))
  }),
  rest.post(`${config.urls.api}v1/admin/grants/programs`, async (_req, res, ctx) => {
    return res(ctx.status(201), ctx.json({ data: mockGrantPrograms[0] }))
  }),
  rest.patch(`${config.urls.api}v1/admin/grants/programs/:programId`, async (_req, res, ctx) =>
    res(ctx.status(200), ctx.json({ data: mockGrantPrograms[0] }))
  ),
  rest.get(`${config.urls.api}v1/admin/grants/programs/:id/candidates`, async (req, res, ctx) => {
    const searchTerm = (req.url.searchParams.get('searchTerm') || '').toLowerCase()
    const filtered = searchTerm
      ? mockCandidates.filter(c => (c.organisation.name || '').toLowerCase().includes(searchTerm))
      : mockCandidates

    return res(
      ctx.status(200),
      ctx.json({
        data: filtered,
        totalResults: filtered.length,
        pageSize: 100,
        _links: {
          current: `${config.urls.api}v1/admin/grants/programs/1/candidates?pageSize=100`
        }
      })
    )
  }),
  rest.get(`${config.urls.api}v1/admin/grants/programs/:id/task-templates`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: mockTaskTemplates }))
  }),
  rest.post(`${config.urls.api}v1/admin/grants/programs/:programId/task-templates`, async (req, res, ctx) => {
    const body = await req.json()

    return res(ctx.status(201), ctx.json({ id: 'new-template-id', ...body }))
  }),
  rest.patch(
    `${config.urls.api}v1/admin/grants/programs/:programId/task-templates/:templateId`,
    async (req, res, ctx) => {
      const body = await req.json()

      return res(ctx.status(200), ctx.json({ id: req.params.templateId, ...body }))
    }
  ),
  rest.delete(
    `${config.urls.api}v1/admin/grants/programs/:programId/task-templates/:templateId`,
    async (req, res, ctx) => {
      return res(ctx.status(200), ctx.json({ data: { id: req.params.templateId } }))
    }
  ),
  rest.post(`${config.urls.api}v1/admin/grants/programs/:id/candidates/recalculate-states`, async (_, res, ctx) => {
    return res(ctx.status(200))
  }),
  rest.post(
    `${config.urls.api}v1/admin/grants/programs/:programId/candidates/:candidateId/recalculate-state`,
    async (_req, res, ctx) => {
      return res(ctx.status(200))
    }
  ),
  rest.get(`${config.urls.api}v1/admin/grants/candidates/:candidateId`, async (req, res, ctx) => {
    const { candidateId } = req.params as { candidateId: string }
    const base = mockCandidates.find(c => c.id === candidateId) || mockCandidates[0]

    return res(
      ctx.status(200),
      ctx.json({
        data: {
          ...base,
          ...mockCandidateDetailFields
        },
        object: 'candidate'
      })
    )
  }),
  rest.patch(`${config.urls.api}v1/admin/grants/programs/:programId/candidates/:candidateId`, async (_req, res, ctx) =>
    res(ctx.status(200), ctx.json({}))
  ),
  rest.post(
    `${config.urls.api}v1/admin/grants/programs/:programId/candidates/:candidateId/reject`,
    async (_req, res, ctx) => res(ctx.status(200), ctx.json({}))
  ),
  rest.delete(`${config.urls.api}v1/admin/grants/candidates/:candidateId`, async (_req, res, ctx) =>
    res(ctx.status(200), ctx.json({}))
  ),
  rest.get(`${config.urls.api}v1/admin/grants/forms/:formId`, async (_req, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: mockFormDetails }))
  }),
  rest.patch(`${config.urls.api}v2/admin/grants/forms/:formId`, async (_req, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: { id: 'form_123' } }))
  }),
  rest.get(`${config.urls.api}v1/admin/grants/candidates/:candidateId/tasks`, async (_req, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: mockCandidateTasks }))
  }),
  rest.patch(`${config.urls.api}v1/admin/grants/tasks/:taskId`, async (_req, res, ctx) => {
    return res(ctx.status(200), ctx.json({}))
  }),
  rest.get(`${config.urls.api}v1/admin/grants/programs/:programId/task-assignees`, async (_req, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: mockTaskAssignees }))
  }),
  rest.put(`${config.urls.api}v1/admin/grants/programs/:programId/task-assignees`, async (_req, res, ctx) => {
    return res(ctx.status(200), ctx.json({}))
  }),
  rest.get(`${config.urls.api}v1/admin/grants/tasks-auto-assignment-rules`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: mockTaskAutoAssignmentRules }))
  }),
  rest.patch(`${config.urls.api}v1/admin/grants/tasks-auto-assignment-rules/:id`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json({}))
  }),
  rest.delete(`${config.urls.api}v1/admin/grants/tasks-auto-assignment-rules/:id`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: mockTaskAutoAssignmentRules }))
  }),
  rest.post(`${config.urls.api}v1/admin/grants/tasks-auto-assignment-rules`, async (_, res, ctx) => {
    return res(ctx.status(201), ctx.json({ data: { id: mockTaskAutoAssignmentRules[0].id } }))
  }),
  rest.get(`${config.urls.api}v1/admin/grants/programs/:programId/state-machine/metadata`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: mockStateMachineMetadata, object: 'stateMachineMetadata' }))
  }),
  rest.post(`${config.urls.api}v1/admin/grants/questions`, async (_req, res, ctx) => {
    return res(ctx.status(201), ctx.json({ data: { questionId: 'new-question-id-001' } }))
  }),
  rest.get(`${config.urls.api}v1/admin/grants/questions/:questionId`, async (req, res, ctx) => {
    const { questionId } = req.params as { questionId: string }
    const detail = mockStandaloneFormQuestionDetails[questionId]

    if (!detail) {
      return res(ctx.status(404))
    }

    return res(ctx.status(200), ctx.json({ data: detail }))
  }),
  rest.patch(`${config.urls.api}v1/admin/grants/questions/:questionId`, async (_req, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: {} }))
  }),
  rest.get(`${config.urls.api}v1/admin/grants/questions`, async (req, res, ctx) => {
    const partnerId = req.url.searchParams.get('partnerId')
    const search = req.url.searchParams.get('search')

    let filtered = partnerId
      ? mockStandaloneFormQuestionsResponse.data.filter(q => q.partnerId === partnerId)
      : mockStandaloneFormQuestionsResponse.data

    if (search) {
      const lower = search.toLowerCase()
      filtered = filtered.filter(q => {
        const label = q.localisedLabel?.locales?.find(l => l.locale === 'en-US')?.value ?? q.key

        return label.toLowerCase().includes(lower) || q.key.toLowerCase().includes(lower)
      })
    }

    return res(
      ctx.status(200),
      ctx.json({
        ...mockStandaloneFormQuestionsResponse,
        data: filtered,
        totalResults: filtered.length
      })
    )
  })
]
